








































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { EachInformation } from "@/interfaces/general";
import { Mos } from "@/interfaces/general";
import { GlobalMixin } from "@/mixins/global";

@Component({
  components: {},
  computed: {},
  methods: {}
})
export default class ModuleTransition extends Mixins(GlobalMixin) {
  @Prop({ type: Array, required: true }) mos!: Mos[];
  @Prop({ type: String, required: true }) select!: string;
  images: string[] = [];
  title = "";
  carousel = 0;
  link = "";

  get information(): EachInformation[] {
    for (const i of this.mos) {
      if (i.title === this.select) {
        this.images = i.items;
        this.title = i.title;
        this.link = i.link === "Mos" ? "" : i.link;
        return i.information;
      }
    }
    return [];
  }

  get justifyBreakpoint(): string {
    return this.$vuetify.breakpoint.smAndDown ? "center" : "space-around";
  }
}
